import { useCifraClient } from "../cifra-client";

const { cifraClient } = useCifraClient();

export default {
  get(id, options) {
    return cifraClient.get(`/api_publica/v1/recursos/reservas/${id}`, options);
  },
  guardar(datos, options) {
    if (datos.reserva.id) {
      return cifraClient.patch(`/api_publica/v1/recursos/reservas/${datos.reserva.id}`, datos, options);
    }

    return cifraClient.post('/api_publica/v1/recursos/reservas', datos, options);
  },
  mover(datos, options) {
    return cifraClient.patch(`/api_publica/v1/recursos/reservas/${datos.reserva.id}/mover`, datos, options);
  },
  eliminar(id, tipoBorrado, options) {
    const data = { tipo_borrado: tipoBorrado };
    return cifraClient.delete(`/api_publica/v1/recursos/reservas/${id}`, { data }, options);
  },
};
